import classNames from 'classnames';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import Icon, { ICON_TYPES } from '@commons/Icon';

import { isIosDropdownScrollToTopFixEnabled } from '@services/featureFlags';

import { isSafariMobile } from '@utils/browserAgent';
import scrollTop, { getIOSScrollTop, setIOSScrollTop } from '@utils/scrollTop';

import styles from './modal.scss';


interface ModalProps {
  cancelButtonLabel?: string;
  children?: React.ReactNode;
  label?: string;
  modalBackdropStyles?: string;
  modalBodyStyles?: string;
  modalContainerStyles?: string;
  modalHeaderStyles?: string;
  onClickHide?: (...args: unknown[]) => unknown;
  scrollTop?: number;
  shouldRender?: boolean;
}


export default class Modal extends Component<ModalProps> {
  static defaultProps = {
    scrollTop: 0,
    shouldRender: true
  };

  constructor(props) {
    super(props);

    this._$surveyDOM = document.getElementById('survey');

    this.handleOnClickHide = this.handleOnClickHide.bind(this);
    this.setRefCancelButton = this.setRefCancelButton.bind(this);
  }

  UNSAFE_componentWillMount() {
    const container = document.createElement('div');
    document.body.appendChild(container);
    if (isSafariMobile() && isIosDropdownScrollToTopFixEnabled()) {
      this.safariScrollTop = getIOSScrollTop();
    }
    this._$container = container;
  }

  componentDidMount() {
    const bodyClassNames = document.body.className.split(' ');
    const idxOfModalOpen = bodyClassNames.indexOf('modal_modalOpen');
    if (idxOfModalOpen !== -1) return;

    bodyClassNames.push('modal_modalOpen');
    document.body.className = bodyClassNames.join(' ');
    document.body.style.top = '-' + this.props.scrollTop + 'px';
    if (this._$surveyDOM) this._$surveyDOM.setAttribute('aria-hidden', 'true');

    if (this._$cancelButton) this._$cancelButton.focus();
  }

  componentWillUnmount() {
    const bodyClassNames = document.body.className.split(' ');
    const idxOfModalOpen = bodyClassNames.indexOf('modal_modalOpen');
    if (idxOfModalOpen === -1) return;

    bodyClassNames.splice(idxOfModalOpen, 1);
    document.body.className = bodyClassNames.join(' ');
    document.body.style.top = '';
    scrollTop(this.props.scrollTop);
    if (
      isSafariMobile() &&
      (this.safariScrollTop || this.safariScrollTop === 0) &&
      isIosDropdownScrollToTopFixEnabled()
    ) {
      setIOSScrollTop(this.safariScrollTop);
    }
    if (this._$surveyDOM) this._$surveyDOM.removeAttribute('aria-hidden');
    document.body.removeChild(this._$container);
  }

  setRefCancelButton(cancelButton) {
    this._$cancelButton = cancelButton;
  }

  handleOnClickHide(e) {
    e.preventDefault();
    if (this.props.onClickHide) this.props.onClickHide();
  }

  render() {
    if (!this.props.shouldRender || !this._$container) return null;

    const {
      cancelButtonLabel,
      label,
      modalBackdropStyles,
      modalBodyStyles,
      modalContainerStyles,
      modalHeaderStyles,
      children
    } = this.props;

    const containerStyles = classNames(styles.modalContainer, modalContainerStyles);
    const backdropStyles = classNames(styles.modalBackdrop, modalBackdropStyles);
    const bodyStyles = classNames(styles.modalBody, modalBodyStyles);
    const headerStyles = classNames(styles.modalHeader, modalHeaderStyles);

    const modal = (
      <div role="dialog" className={backdropStyles}>
        <div className={containerStyles}>
          <div className={headerStyles}>
            <span
              className={styles.modalLabel}
              aria-hidden="true"
              dangerouslySetInnerHTML={{ __html: label }}
            />
            <a
              href=""
              aria-label={cancelButtonLabel}
              className={styles.closeIconContainer}
              onClick={this.handleOnClickHide}
              ref={this.setRefCancelButton}
              role="button"
              tabIndex="0">
              <Icon containerStyles={styles.closeIcon} type={ICON_TYPES.CLOSE} />
            </a>
          </div>
          <div className={bodyStyles}>{children}</div>
        </div>
      </div>
    );

    return ReactDOM.createPortal(modal, this._$container);
  }
}
